import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import { doVxqlRequest } from './VxqlStore';
import { GetActorsByIds, GetVideosByIds } from './Slotmachine.Queries.js';

let _actors = [];
let _videos = [];

const SlotmachineStore = assign({}, FluxEventEmitter.prototype, {
	getActorsByIds: function (ids, callback) {
		if (_actors.length > 0) {
			callback(_actors);
		} else {
			const clb = (data) => {
				_actors = [...data.data.models_v2.items];
				callback(_actors);
			};
			loadActors(ids, clb);
		}
	},
	getVideosByIds: function (videos, callback) {
		if (_videos.length > 0) {
			callback(_videos);
		} else {
			const clb = (data) => {
				_videos = data.data;
				callback(_videos);
			};
			loadVideos(videos, clb);
		}
	},
});

function loadActors(ids, callback) {
	const args = { filter: { ids }, first: ids.length };
	doVxqlRequest(GetActorsByIds, args).then((result) => callback(result));
}

function loadVideos(videos = [], callback) {
	const ids = videos.map(v => v.id);
	const args = { ids };
	doVxqlRequest(GetVideosByIds, args).then((result) => callback(result));
}

export default SlotmachineStore;
